module.exports = __webpack_public_path__ + "media/images/flags/vg-1eb5fe2d8bcffe4ddac93d92518f0d93.svg";